import { getQaSelector } from '../../../utils/common'
import { Skeleton } from '../../Skeleton'
import {
  GRETA_FEED_SKELETON_TURN_COUNT,
  QA_NAME_GRETA_AI_CHAT_MESSAGE_LIST_SKELETON,
} from '../GretaAIChat.constants'

import {
  ANSWER_LINE_WIDTHS,
  QUESTION_WIDTHS,
} from './GretaAIChatMessageListSkeleton.constants'

import * as styles from './GretaAIChatMessageListSkeleton.module.css'

function GretaAIChatMessageListSkeleton() {
  const qaProps = getQaSelector({
    value: QA_NAME_GRETA_AI_CHAT_MESSAGE_LIST_SKELETON,
  })

  return (
    <div {...qaProps} aria-hidden className={styles.skeleton}>
      {Array.from({ length: GRETA_FEED_SKELETON_TURN_COUNT }).map(
        (_, turnIndex) => (
          <div className={styles.turn} key={turnIndex}>
            <div
              className={styles.question}
              style={{
                width: QUESTION_WIDTHS[turnIndex % QUESTION_WIDTHS.length],
              }}
            >
              <Skeleton className={styles.questionLine} />
            </div>

            <div className={styles.answer}>
              {ANSWER_LINE_WIDTHS[turnIndex % ANSWER_LINE_WIDTHS.length].map(
                (width, lineIndex) => (
                  <Skeleton
                    className={styles.answerLine}
                    key={lineIndex}
                    style={{ width }}
                  />
                )
              )}
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default GretaAIChatMessageListSkeleton
